/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum10filesupto5mbeach6Inputs */

const en_maximum10filesupto5mbeach6 = /** @type {(inputs: Maximum10filesupto5mbeach6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum 10 files, up to 5MB each`)
};

const de_maximum10filesupto5mbeach6 = /** @type {(inputs: Maximum10filesupto5mbeach6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal 10 Dateien, jeweils bis zu 5 MB groß.`)
};

/**
* | output |
* | --- |
* | "Maximum 10 files, up to 5MB each" |
*
* @param {Maximum10filesupto5mbeach6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maximum10filesupto5mbeach6 = /** @type {((inputs?: Maximum10filesupto5mbeach6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum10filesupto5mbeach6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maximum10filesupto5mbeach6(inputs)
	return de_maximum10filesupto5mbeach6(inputs)
});
export { maximum10filesupto5mbeach6 as "maximum10FilesUpTo5MBEach" }